import { getPreviousYear, getUpcomingYear } from "./DateHelpers";

export const getLastThreeYearAsOptions = () => {
    return [
        { label: getUpcomingYear(1), value: getUpcomingYear(1) },
        { label: getPreviousYear(0), value: getPreviousYear(0) },
        { label: getPreviousYear(1), value: getPreviousYear(1) },
        { label: getPreviousYear(2), value: getPreviousYear(2) }
    ];
}

export const getPreviousCurrentAndNextYearAsOption = () => {
    return [
        { label: getPreviousYear(0), value: getPreviousYear(0) },
        { label: getPreviousYear(1), value: getPreviousYear(1) },
        { label: getUpcomingYear(1), value: getUpcomingYear(1) },
    ];
}